import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import ModuleList, { Props } from '../_components/ModuleList';
import { OnModuleMove } from '../_actions/ModuleListActions';

const mapStateToProps = (store:Store, props:Props) => ({
	moduleIds: store.getIn(['create', 'layerList', 'layers', store.getIn(['create', 'layerList', 'selectedLayerId']), 'modules']),
	selectedModuleId: store.getIn(['create', 'moduleList', 'selectedModuleId']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	moveModule: (moduleId: string, position:number) => dispatch(OnModuleMove(moduleId, position)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModuleList);